import { Question } from "./question";

interface IAssessment {
    assessmentId: string;
    group: number;
    year: number;
    sequence: number;
    beginEffectiveUtcDate: string;
    endEffectiveUtcDate: string;
    minutesPerQuestion: number;
    questionCount: number;
    currentQuestionId: number;
    currentQuestionSequence: number;
}

export class Assessment implements IAssessment {
    assessmentId: string;
    assessmentResultId: string;
    assessmentSequence: string;
    credentialCode: string;
    group: number;
    year: number;
    sequence: number;
    beginEffectiveUtcDate: string;
    endEffectiveUtcDate: string;
    pastAssessment: boolean;
    minutesPerQuestion: number;
    questionCount: number;
    currentQuestionId: number;
    currentQuestionSequence: number;
    isCompleted: boolean;
    isPublished: boolean;
    opensOn: string;
    closesOn: string;
    questionsTotalCount: string;
    questionsAnsweredCount: string;
    questionsUnAnsweredCount: string;
    questionsCorrectCount: string;
    questions: Question[] = new Array<Question>();
    
}
